import { formatarTamanhoMegabytes } from "../../../../../Funcoes";

export default function Registro({
    indice,
    dados,
    dadosEmpresa,

    clicouRegistro
}){

    return <> 

        <tr
            className={['registro'].join(' ')}
            style={{cursor: 'pointer'}}
            onClick={clicouRegistro}
        >

            <td className={'text-center font-weight-bold indice'}>
                {indice}
            </td>

            <td className="descricao">
                <div className="d-flex align-items-center" style={{gap: 3}}>
                    {dadosEmpresa.razaoSocial} <small>({dadosEmpresa.codigo})</small>
                </div>
                <div className="totais">
                    <small className="geral">
                        <b>Tamanho: </b> {formatarTamanhoMegabytes(dados.tamanho)}
                    </small>
                    <small className="v1">
                        <b>Cabos: </b> {formatarTamanhoMegabytes(dados.dados.tabelas.cabos.tamanho)} | {dados.dados.tabelas.cabos.registros.total} registros
                    </small>
                    <small className="v2">
                        <b>Equipamentos: </b> {formatarTamanhoMegabytes(dados.dados.tabelas.equipamentos.tamanho)} | {dados.dados.tabelas.equipamentos.registros.total} registros
                    </small>
                    <small className="v3">
                        <b>Itens rede: </b> {formatarTamanhoMegabytes(dados.dados.tabelas.itensRede.tamanho)} | {dados.dados.tabelas.itensRede.registros.total} registros
                    </small>
                </div>
            </td>
        </tr>
    </>
}